import { gql } from '__generated__';

export default gql(`
  mutation SaveReview($input: SaveReviewInput!) {
    saveReview(input: $input) {
      id
      rating
      aspects
      comment
      created_at
    }
  }
`);
